// extracted by mini-css-extract-plugin
module.exports = {"craftWelcomeMessageForm":"CreateEditSendMessageActionForm_craftWelcomeMessageForm__ZFKc_"};